import React, { useEffect, useState } from 'react'
import Navigation from './Navigation'
import { motion } from "framer-motion"
import { Link, useParams } from 'react-router-dom'
import axios from 'axios';
import Loading from './layouts/Loading';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, minusQty, plusQty } from '../Slices/cart/Cart';
import ZoomImage from './layouts/ZoomImage';
import { IoWarning } from 'react-icons/io5';
import { GrReturn } from 'react-icons/gr';
import { FaShippingFast, FaTruckPickup, FaHeart, FaShare, FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import ProductSlider from './Carousal/ProductSlider';

function SingleProduct() {
  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart);
  const productId = useParams();
  
  // Get current quantity from cart if exists
  const latestqty = cart.find(item => item.id === parseInt(productId.id));
  
  const [product, setProduct] = useState('');
  const [allColors, setAllColors] = useState([]);
  const [allSizes, setAllSizes] = useState([]);
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const [mainImage, setMainImage] = useState('');
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('description');

  const weburl = useSelector(state => state.constants.weburl);
  const [products, setProducts] = useState([]);
  const [mostlySold, setMostlySold] = useState([]);

  const fetchSizeImages = (e, sizeId, sizeName) => {
    e.preventDefault();
    setSelectedSize(sizeId);
    axios.get(`api/onlinestore/product/detail/${productId.id}/${sizeId}`).then(res => {
      setAllColors(res.data.allColors);
      setSelectedColor(res.data.allColors[0]?.color.id || '');
      setAllSizes(res.data.allSizes);
      setMainImage(res.data.product.image);
      setProduct({
        ...res.data.product,
        colorName: res.data.allColors[0]?.color.name || '',
        sizeName: res.data.allSizes[0]?.name || '',
      });
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setLoading(false);
    });
  }

  const handleSelectColor = (colorId, colorName) => {
    setSelectedColor(colorId);
    setProduct(prev => ({ ...prev, colorName }));
  }

  // Your original add to cart function
  const handleAddToCart = (item) => {
    dispatch(addToCart(item));
  };

  // Your original minus quantity function
  const handleMinusQty = (itemId) => {
    dispatch(minusQty(itemId));
  };

  // Your original plus quantity function
  const handlePlusQty = (itemId) => {
    dispatch(plusQty(itemId));
  };

  useEffect(() => {
    // Fetch product details
    axios.get(`api/onlinestore/product/detail/${productId.id}`).then(res => {
      setAllColors(res.data.allColors || []);
      if (res.data.allColors.length > 0) {
        setSelectedColor(res.data.allColors[0].color.id);
      }
      setAllSizes(res.data.allSizes || []);
      if (res.data.allSizes.length > 0) {
        setSelectedSize(res.data.allSizes[0].id);
      }
      setMainImage(res.data.product.image);
      setProduct({
        ...res.data.product,
        sizeName: res.data.allSizes.length > 0 ? res.data.allSizes[0].name : '',
        colorName: res.data.allColors.length > 0 ? res.data.allColors[0].color.name : '',
      });
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setLoading(false);
    });

    // Fetch related products
    axios.get(`api/onlinestore/related/products/${productId.id}`).then(res => {
      setProducts(res.data.products);
      setMostlySold(res.data.mostsolditems);
    }).catch(err => {
      console.log(err);
    });
  }, [productId.id]);

  // Calculate discount percentage
  const discountPercent = product.unitretailprice && product.unitsaleprice && product.unitretailprice < product.unitsaleprice
    ? Math.round(((product.unitsaleprice - product.unitretailprice) / product.unitsaleprice) * 100)
    : 0;



  // Rating component
  const renderRating = (rating = 4.5) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={i} className="text-yellow-400" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" className="text-yellow-400" />);
    }
    while (stars.length < 5) {
      stars.push(<FaRegStar key={stars.length} className="text-yellow-400" />);
    }
    return stars;
  };

  if (loading) return <Loading />;

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <Navigation name={product.name} />

      {/* Main Product Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          
          {/* Thumbnail Gallery - Left Side */}
          <div className="lg:col-span-1">
            <div className="flex lg:flex-col gap-3 overflow-x-auto lg:overflow-x-visible">
              {/* Main Product Thumbnail */}
              <div 
                onMouseEnter={() => setMainImage(product.image)}
                className="cursor-pointer rounded-lg overflow-hidden border-2 border-transparent hover:border-blue-500 transition-all"
              >
                <img 
                  alt={product.name} 
                  src={`${weburl}/${product.image}`} 
                  className="w-20 h-20 object-cover rounded-lg"
                />
              </div>
              
              {/* Color Variant Thumbnails */}
              {allColors.map((item) => (
                <div 
                  key={item.id}
                  onMouseEnter={() => setMainImage(item.image_url)}
                  className="cursor-pointer rounded-lg overflow-hidden border-2 border-transparent hover:border-blue-500 transition-all"
                >
                  <img 
                    alt={item.color?.name} 
                    src={`${weburl}/${item.image_url}`} 
                    className="w-20 h-20 object-cover rounded-lg"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Main Image - Center */}
          <div className="lg:col-span-5">
            <div className="bg-gray-50 rounded-2xl p-4 flex items-center justify-center min-h-[400px] lg:min-h-[500px]">
              <ZoomImage 
                src={`${weburl}/${mainImage}`} 
                alt={product.name}
                className="max-h-[450px] w-auto object-contain"
              />
            </div>
          </div>

          {/* Product Details - Right Side */}
          <div className="lg:col-span-6">
            {/* Badges */}
            <div className="flex flex-wrap gap-2 mb-3">
              {discountPercent > 0 && (
                <span className="bg-red-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                  {discountPercent}% OFF
                </span>
              )}
              {product.shipping === '1' && (
                <span className="bg-green-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                  Free Shipping
                </span>
              )}
              {product.is_new && (
                <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                  New Arrival
                </span>
              )}
            </div>

            {/* Title & Category */}
            <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
              {product.name}
            </h1>
            <p className="text-gray-500 text-sm mb-3">{product.category?.name}</p>

            {/* Rating */}
            <div className="flex items-center gap-2 mb-4">
              <div className="flex gap-1">
                {renderRating(4.5)}
              </div>
              <span className="text-gray-400 text-sm">(128 reviews)</span>
              <button className="text-gray-400 hover:text-red-500 transition">
                <FaHeart />
              </button>
              <button className="text-gray-400 hover:text-blue-500 transition">
                <FaShare />
              </button>
            </div>

            {/* Pricing */}
            <div className="mb-4">
              {product.unitretailprice && product.unitretailprice !== '0' ? (
                <div className="flex items-baseline gap-3">
                  <span className="text-3xl font-bold text-green-600">
                    Rs. {parseInt(product.unitsaleprice).toLocaleString()}
                  </span>
                  {product.unitsaleprice && product.unitsaleprice !== product.unitretailprice && (
                    <>
                      <span className="text-lg text-gray-400 line-through">
                        Rs. {parseInt(product.unitretailprice).toLocaleString()}
                      </span>
                      <span className="text-red-600 font-semibold">
                        Save Rs. {(product.unitsaleprice - product.unitretailprice).toLocaleString()}
                      </span>
                    </>
                  )}
                </div>
              ) : (
                <p className="text-lg text-gray-500">Price on request</p>
              )}
            </div>

            {/* Color Selection */}
            {allColors.length > 0 && (
              <div className="mb-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="font-semibold text-gray-800">Color:</span>
                  <span className="text-gray-600 capitalize">{product.colorName || allColors[0]?.color?.name}</span>
                </div>
                <div className="flex flex-wrap gap-3">
                  {allColors.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => handleSelectColor(item.color.id, item.color.name)}
                      className={`w-12 h-12 rounded-full transition-all ${
                        selectedColor === item.color.id
                          ? 'ring-2 ring-blue-500 ring-offset-2 scale-110'
                          : 'hover:scale-105'
                      }`}
                      style={{ backgroundColor: item.color.name.toLowerCase() }}
                      title={item.color.name}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* Size Selection */}
            {allSizes.length > 0 && (
              <div className="mb-5">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-semibold text-gray-800">Size:</span>
                  <button className="text-sm text-blue-600 hover:underline">
                    Size Guide
                  </button>
                </div>
                <div className="flex flex-wrap gap-2">
                  {allSizes.map((item) => (
                    <button
                      key={item.id}
                      onClick={(e) => fetchSizeImages(e, item.id, item.name)}
                      className={`px-4 py-2 rounded-lg border font-medium transition-all ${
                        selectedSize === item.id
                          ? 'border-blue-600 bg-blue-50 text-blue-600'
                          : 'border-gray-300 hover:border-blue-400 text-gray-700'
                      }`}
                    >
                      {item.name}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Quantity Selector */}
            <div className="mb-5">
              <span className="font-semibold text-gray-800 mb-2 block">Quantity:</span>
              <div className="flex items-center gap-3">
                <div className="flex items-center border rounded-lg overflow-hidden">
                  <button
                    onClick={() => handleMinusQty(product.id)}
                    className="px-4 py-2 text-xl font-bold hover:bg-gray-100 transition"
                  >
                    -
                  </button>
                  <span className="w-16 text-center font-semibold"> {latestqty ? latestqty.qty : 1}</span>
                  <button
                     onClick={() => handlePlusQty(product.id)}
                    className="px-4 py-2 text-xl font-bold hover:bg-gray-100 transition"
                  >
                    +
                  </button>
                </div>
                <p className="text-sm text-gray-500">
                  {product.qty > 0 ? `${product.qty} items available` : 'Out of stock'}
                </p>
              </div>
            </div>

            {/* Add to Cart Button */}
            <div className="mb-5">
              {product.unitretailprice && product.unitretailprice !== '0' ? (
                product.qty > 0 ? (
                  <button
                   onClick={() => handleAddToCart(product)} 
                    className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-4 rounded-xl transition-all transform hover:scale-[1.02] active:scale-95"
                  >
                    Add to Cart
                  </button>
                ) : (
                  <button className="w-full bg-gray-300 text-gray-500 font-bold py-4 rounded-xl cursor-not-allowed">
                    Out of Stock
                  </button>
                )
              ) : (
                <Link to="/quote">
                  <button className="w-full bg-yellow-700 hover:bg-yellow-800 text-white font-bold py-4 rounded-xl transition-all">
                    Request Quote
                  </button>
                </Link>
              )}
            </div>

            {/* Delivery & Returns Info */}
            <div className="bg-gray-50 rounded-xl p-4 mb-5">
              <div className="grid grid-cols-2 gap-3">
                <div className="text-center">
                  <IoWarning className="w-6 h-6 text-blue-600 mx-auto mb-1" />
                  <p className="text-xs text-gray-600">Secure Checkout</p>
                </div>
                <div className="text-center">
                  <GrReturn className="w-6 h-6 text-blue-600 mx-auto mb-1" />
                  <p className="text-xs text-gray-600">30 Days Return</p>
                </div>
                <div className="text-center">
                  <FaShippingFast className="w-6 h-6 text-blue-600 mx-auto mb-1" />
                  <p className="text-xs text-gray-600">Free Shipping*</p>
                </div>
                <div className="text-center">
                  <FaTruckPickup className="w-6 h-6 text-blue-600 mx-auto mb-1" />
                  <p className="text-xs text-gray-600">Free Pickup</p>
                </div>
              </div>
            </div>

            {/* SKU & Category Info */}
            <div className="border-t pt-4 text-sm text-gray-500">
              <div className="flex flex-wrap gap-4">
                <div>
                  <span className="font-semibold">SKU:</span> {product.alias || 'N/A'}
                </div>
                <div>
                  <span className="font-semibold">Category:</span> {product.category?.name}
                </div>
                {product.tags && (
                  <div>
                    <span className="font-semibold">Tags:</span> {product.tags}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Product Tabs Section */}
        <div className="mt-12">
          <div className="border-b">
            <div className="flex flex-wrap gap-6">
              {['description', 'specifications', 'reviews'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`py-3 px-1 font-semibold transition-all relative ${
                    activeTab === tab
                      ? 'text-blue-600 border-b-2 border-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>
          </div>

          <div className="py-6">
            {activeTab === 'description' && (
              <div className="prose max-w-none">
                <p className="text-gray-600 leading-relaxed">{product.description}</p>
              </div>
            )}
            {activeTab === 'specifications' && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="font-semibold">Material</p>
                  <p className="text-gray-600">Premium Quality</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="font-semibold">Warranty</p>
                  <p className="text-gray-600">1 Year Manufacturer Warranty</p>
                </div>
              </div>
            )}
            {activeTab === 'reviews' && (
              <div className="text-center py-8">
                <p className="text-gray-500">No reviews yet. Be the first to review!</p>
                <button className="mt-4 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                  Write a Review
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Related Products Sections */}
        <div className="mt-12 space-y-12">
          {products.length > 0 && (
            <ProductSlider data={products} name="Similar Items You May Like" />
          )}
          {mostlySold.length > 0 && (
            <ProductSlider data={mostlySold} name="Best Selling Items" />
          )}
        </div>
      </div>
    </motion.div>
  )
}

export default SingleProduct